import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { getJwtToken, END_POINT } from '../../Redux/AdminReducer/action';
import CustomInput from '../../Components/CommonComponents/CustomInput';
import SearchableSelect from '../../Components/CommonComponents/SearchableSelect';

// The inventory medicine list, fetched once per page load and shared by every
// row of the order and return forms.
let medicinesRequest = null;
const loadMedicines = () => {
  if (!medicinesRequest) {
    medicinesRequest = axios
      .get(`${END_POINT}/inventory/inventoryMedicines`, { headers: { Authorization: getJwtToken() } })
      .then((res) => (Array.isArray(res?.data) ? res.data : []))
      .catch((error) => {
        console.error('Failed to load inventory medicines', error);
        medicinesRequest = null;
        return [];
      });
  }
  return medicinesRequest;
};

// The same medicine name is stocked in several potencies and companies, so
// the suggestion shows enough to tell them apart.
const medicineLabel = (item) =>
  [item?.nameOfMedicine, item?.potencyOrPower, item?.company, item?.typeOfMedicine].filter(Boolean).join(' · ');

// Name of Medicine with suggestions from the inventory. Picking one calls
// onPick(item) so the row can fill its other fields; anything typed that is
// not on the list is kept as a new medicine name via onType(text).
export default function MedicineNameField({ value, disabled, onPick, onType }) {
  const [medicines, setMedicines] = useState([]);

  useEffect(() => {
    if (disabled) return undefined;
    let cancelled = false;
    loadMedicines().then((list) => {
      if (!cancelled) setMedicines(list);
    });
    return () => {
      cancelled = true;
    };
  }, [disabled]);

  const byLabel = useMemo(() => {
    const map = new Map();
    medicines.forEach((item) => {
      const label = medicineLabel(item);
      if (label && !map.has(label)) map.set(label, item);
    });
    return map;
  }, [medicines]);
  const options = useMemo(() => [...byLabel.keys()], [byLabel]);

  if (disabled) {
    return <CustomInput disabled name="nameOfMedicine" type="text" placeholder="Medicine name" value={value || ''} onChange={() => {}} />;
  }

  return (
    <SearchableSelect
      name="nameOfMedicine"
      placeholder="Search medicine"
      value={value || ''}
      options={options}
      allowCustom
      maxResults={50}
      emptyMessage="Not in inventory - the typed name will be used"
      onChange={(event) => {
        const text = event.target.value;
        const item = byLabel.get(text);
        if (item) onPick(item);
        else onType(text);
      }}
    />
  );
}
